import { render } from "./EmployeeVerificationView.vue?vue&type=template&id=2a1c9ce6&scoped=true"
import script from "./EmployeeVerificationView.vue?vue&type=script&lang=js"
export * from "./EmployeeVerificationView.vue?vue&type=script&lang=js"

import "./EmployeeVerificationView.vue?vue&type=style&index=0&id=2a1c9ce6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\mridu\\BGI_Project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a1c9ce6"]])

export default __exports__